import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '../shared/Card';
import { formatDate } from '../../utils/helpers';

const ExcursionItem = ({ item, isSelected, onAdd, onRemove }) => {
  const sortedDates = item.dates.sort(
    (d1, d2) =>
      new Date(d1.capacity_start_date) - new Date(d2.capacity_start_date)
  );
  const [selectedDate, setSelectedDate] = useState(String(sortedDates[0].id));

  return (
    <Card title={item.name} startingPrice={item.dates[0].capacity_price}>
      <div className="extras-item__body">
        <img src={item.image_url} width={150} alt={item.name} />
        <label
          className={classNames('field__label', {
            'field__input--selected': isSelected,
          })}
        >
          <select
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          >
            <option value="">Select Date</option>
            {sortedDates.map((d) => (
              <option key={d.id} value={d.id}>
                {formatDate(d.capacity_start_date, 'MM/dd/yyyy')}
              </option>
            ))}
          </select>
        </label>
      </div>

      {!isSelected ? (
        <button
          className="extras-item__button"
          onClick={() => onAdd(selectedDate)}
        >
          Select
        </button>
      ) : (
        <button
          className="extras-item__button field__input--selected"
          onClick={onRemove}
        >
          Remove
        </button>
      )}
    </Card>
  );
};

ExcursionItem.propTypes = {
  item: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default ExcursionItem;
